
import { useTranslation } from 'react-i18next';
import { CandidateDetail } from '../../../../models/candidate-detail.model';
import { Section, Text } from '../../talent.styled';
import AcademicFormationExperience from '../academic-formation/academic-formation';
import Certificates from '../certificates/certificates';
import ProfessionalExperience from '../professional-experience/professional-experience';
import { Content, TitleAbout } from './about.styled';
import Articles from '../articles/articles';
import Projects from '../projects/projects';
import { useCallback, useMemo } from 'react';
import NoInformation from '../no-information/no-information';
import  ProfessionalExperienceModel from '../../../../models/professional-experience.model';

interface AboutPropos {
    candidate?: CandidateDetail | null;
    isLocked?: boolean | true;
    //TODO: remover quando fizer a migração completa dos dados
    professionalExperiences?: ProfessionalExperienceModel[];
}

const About: React.FC<AboutPropos> = ({ candidate, isLocked, professionalExperiences }) => {
    const { t } = useTranslation('private-home-page');

    const verify = useCallback((list?: any[]): boolean => {
        return !!list && list.length > 0;
    }, []);

    const emptyProfile = useMemo((): boolean => {
        return (
            !verify(candidate?.professional_experience) &&
            !verify(candidate?.academic_formation) &&
            !verify(candidate?.achievements) &&
            !verify(candidate?.articles) &&
            !verify(candidate?.lab_projects.results)
        );
    }, [candidate, verify]);

    return (
        <Content>
            {candidate?.about &&
                <Section>
                    <TitleAbout>{t('talent.about')}</TitleAbout>
                    <Text>{candidate?.about}</Text>
                </Section>
            }

            {emptyProfile && <NoInformation />}
            
            {(professionalExperiences && professionalExperiences.length > 0) &&
                <ProfessionalExperience professionalExperiences={professionalExperiences} />
            }

            {(candidate?.academic_formation && candidate?.academic_formation.length > 0) &&
                <AcademicFormationExperience candidate={candidate} />
            }

            {candidate && candidate?.achievements?.length > 0 &&
                <Certificates candidate={candidate} isLocked={isLocked}/>
            }

            {candidate && candidate?.articles?.length > 0 &&
                <Articles candidate={candidate} isLocked={isLocked}/>
            }

            {candidate && candidate?.lab_projects?.total > 0 &&
                <Projects candidate={candidate} isLocked={isLocked}/>
            }
        </Content>
    )
}

export default About;
